import { useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { toggleAuthModal } from '../../../../../actions/homeSearchAuthModal'
import { selectClientIsGuest } from '../../../../../store/selectors/client'
import { ConfirmSavedSearchModal } from './ConfirmSavedSearchModal'
import { RootState } from '../../../../../types/rootState'
import { Button, Icon } from '@homebotapp/hb-react-component-catalog'
import { SavedSearchIcon } from '../SavedSearchIcon'

export const MSG = defineMessages({
  buttonOffAriaLabel: {
    id: 'HomeSearch.listings.saveSearchButtonOffAriaLabel',
    defaultMessage: 'Click to save this search'
  },
  saveSearch: {
    id: 'HomeSearch.listings.saveSearchButton',
    defaultMessage: 'Save search'
  }
})

export const ConfirmSavedSearchButton = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const clientIsGuest = useSelector(selectClientIsGuest)
  const [showModal, setShowModal] = useState(false)
  const isPublic = useSelector<RootState, boolean>(state => state.auth.isPublic)

  const showConfirmModalOrAuth = () => (clientIsGuest ? dispatch(toggleAuthModal(true)) : setShowModal(true))

  if (isPublic) {
    return null
  }

  return (
    <>
      <Button
        minW='7rem'
        onClick={() => showConfirmModalOrAuth()}
        data-qa='turnOnListingsAlertsButton'
        aria-label={intl.formatMessage(MSG.buttonOffAriaLabel)}
        leftIcon={<SavedSearchIcon />}
      >
        {intl.formatMessage(MSG.saveSearch)}
      </Button>
      <ConfirmSavedSearchModal showModal={showModal} hideModal={() => setShowModal(false)} />
    </>
  )
}
